import styled from 'styled-components';

export const SubSwitchGroupContent = styled.div`
    margin-top: 12px;
    margin-left: 46px;
`;
